import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useTranslation } from '../../i18n/useTranslation';
import '../styles/booking.css';
import { LanguageSwitcher } from '../components/LanguageSwitcher.js';
import {
  buildTelegramReferralRedirect,
  buildVkReferralRedirect,
} from '../../shared/config/referralUrls.js';

const JoinPage: React.FC = () => {
  const { t } = useTranslation();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  useEffect(() => {
    const handleReferral = async () => {
      const refCode = searchParams.get('ref');

      if (!refCode) {
        setError(t('booking.join.missingRef'));
        setLoading(false);
        return;
      }

      try {
        localStorage.setItem('referralCode', refCode);
        const userAgent = navigator.userAgent.toLowerCase();

        if (userAgent.includes('telegram')) {
          window.location.href = buildTelegramReferralRedirect(refCode);
        } else if (userAgent.includes('vk')) {
          const vkRedirect = buildVkReferralRedirect(refCode);
          if (!vkRedirect) {
            setError(t('booking.join.vkAppNotConfigured'));
            return;
          }
          window.location.href = vkRedirect;
        } else {
          setSuccessMessage(t('booking.join.savedMessage', { code: refCode }));
        }
      } catch {
        setError(t('booking.join.processError'));
      } finally {
        setLoading(false);
      }
    };

    handleReferral();
  }, [searchParams, t]);

  if (loading) {
    return (
      <div className="booking-page-center">
        <div className="booking-card-lang-row" style={{ width: '100%', maxWidth: 400, margin: '0 auto var(--spacing-md)' }}>
          <LanguageSwitcher />
        </div>
        <p className="booking-text-muted booking-loading-text">{t('booking.join.loading')}</p>
      </div>
    );
  }

  return (
    <div className="booking-page-center">
      <div className="booking-card booking-card-narrow">
        <div className="booking-card-lang-row">
          <LanguageSwitcher />
        </div>
        <h1 className="booking-title">{t('booking.join.title')}</h1>

        {error && (
          <div className="booking-alert booking-alert-error">
            {error}
          </div>
        )}
        {successMessage && (
          <div className="booking-alert booking-alert-success">
            {successMessage}
          </div>
        )}

        {successMessage && (
          <>
            <p className="booking-join-instruction">{t('booking.join.instructionTitle')}</p>
            <ul className="booking-list-narrow">
              <li>{t('booking.join.telegram')}</li>
              <li>{t('booking.join.vk')}</li>
              <li>{t('booking.join.android')}</li>
            </ul>
          </>
        )}

        <button
          type="button"
          onClick={() => navigate('/')}
          className="booking-button booking-button-primary"
        >
          {t('booking.join.backHome')}
        </button>
      </div>
    </div>
  );
};

export default JoinPage;
